import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import styled from 'styled-components'
import { Delete } from '@mui/icons-material'
import { breakpoints } from '../../../../theme/breakpoints'
import { LaborItem } from '../../../../store/models/LaborModel'
import { defaultTheme } from '../../../../theme'
import { useLaborLookup } from '../../../../store/labor/LaborStore'

interface LaborRowInterface {
  labor: LaborItem
  removeLabor: (laborId: number) => void
}

export const LaborRow = observer(
  ({ labor, removeLabor }: LaborRowInterface): ReactElement => {
    const { calculateLaborCost } = useLaborLookup()
    const formattedPrice = calculateLaborCost(labor).toFixed(2)

    return (
      <Row>
        <Td>{labor.laborId}</Td>
        <Td style={{ width: '35%' }}>
          {labor.laborDescription} <br />
          <AdditionalText>{labor.miscellaneousText}</AdditionalText>
        </Td>
        <Td>{labor.laborRate}</Td>
        <Td>{labor.hours}</Td>
        <Td>{labor.warrantyHrs}</Td>
        <Td>{labor.skillLevel}</Td>
        <Td>${formattedPrice}</Td>
        <Td>
          <Delete
            onClick={() => removeLabor(labor.laborId)}
            style={{ cursor: 'pointer' }}
            htmlColor={defaultTheme.colors.red}
          />
        </Td>
      </Row>
    )
  }
)

const Row = styled.tr`
  text-align: initial;
  background: ${defaultTheme.colors.white};
  box-shadow: inset 0px -1px 0px ${defaultTheme.colors.border};
  border: 24px;
  max-width: 100%;
  font-family: Roboto, serif;
  font-weight: bold;
  @media (max-width: ${breakpoints.mobileLarge}px) {
    .hide-cell {
      display: none;
    }
    .td-column {
      display: block;
      flex-direction: column;
    }
  }
  @media (min-width: ${breakpoints.mobileLarge}px) {
    .text-visibility {
      display: none;
    }
  }
`

const Td = styled.td`
  vertical-align: top;
  padding: 25px 12px;
  @media (max-width: ${breakpoints.mobileLarge}px) {
    overflow: hidden;
  }
`

const AdditionalText = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${defaultTheme.colors.greyDark};
`
